/**
 * Shared body scroll lock for modals and drawers.
 *
 * Hiding the body overflow removes the scrollbar, which makes the page content jump
 * sideways on systems with classic (non-overlay) scrollbars. To avoid that, the width
 * of the scrollbar is added as padding on the body while the lock is active, so the
 * content stays exactly where it was.
 *
 * Locks are keyed by owner so several components (e.g. a modal and the terms dialog
 * opened on top of it) can lock independently. The body is only released once every
 * owner has unlocked. Calling lock or unlock twice for the same owner is harmless.
 */

const owners = new Set<string>();
let previousOverflow = "";
let previousPaddingRight = "";

export function lockBodyScroll(owner: string) {
    if (owners.has(owner)) return;

    if (owners.size === 0) {
        const body = document.body;
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

        previousOverflow = body.style.overflow;
        previousPaddingRight = body.style.paddingRight;

        if (scrollbarWidth > 0) {
            const currentPadding = parseFloat(getComputedStyle(body).paddingRight) || 0;
            body.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
        }
        body.style.overflow = "hidden";
    }

    owners.add(owner);
}

export function unlockBodyScroll(owner: string) {
    if (!owners.delete(owner)) return;
    if (owners.size > 0) return;

    document.body.style.overflow = previousOverflow;
    document.body.style.paddingRight = previousPaddingRight;
}
